import { NgModule } from '@angular/core';
import { CompanyOverviewIconsComponent } from './company-overview-icons.component';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { FormatUrlPipeModule, PurchaseHistoryPipeModule } from '../../../pipes';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [CompanyOverviewIconsComponent],
    exports: [CompanyOverviewIconsComponent],
    imports: [
        DisableAutocompleteDirectiveModule,
        MatTooltipModule,
        CommonModule,
        FormatUrlPipeModule,
        PurchaseHistoryPipeModule,
        FontAwesomeModule,
    ]
})
export class CompanyOverviewIconsModule {}
